



// import React, { useState, useEffect } from "react";
// import { Card, CardHeader, CardTitle, CardContent } from "./Card";
// import { Dialog, DialogTitle } from "./DialogBox";
// import { MdBorderHorizontal } from "react-icons/md";
// import { FaExternalLinkAlt } from "react-icons/fa";

// const ApplicationTable = ({ userApplication }) => {
//   const [selectedApp, setSelectedApp] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [showNotification, setShowNotification] = useState(false);
//   const [notificationMessage, setNotificationMessage] = useState("");

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setSelectedApp(null);
//   };

//   const getStatusColor = (status) => {
//     switch (status) {
//       case "Applied":
//         return "bg-yellow-100 text-yellow-800";
//       case "Shortlisted":
//         return "bg-blue-100 text-yellow-800";
//       case "Scheduled":
//         return "bg-purple-100 text-purple-800";
//       case "Interviewed":
//         return "bg-pink-100 text-purple-800";
//       case "Rejected":
//         return "bg-red-100 text-red-800";
//       case "Offer":
//       case "Accepted":
//         return "bg-green-100 text-green-800";
//       default:
//         return "bg-gray-100 text-gray-800";
//     }
//   };

//   // Filter applications by status, ensuring case-insensitive comparison
//   const appliedJobs = userApplication?.filter(app => 
//     app.status?.toLowerCase() === "applied" || app.status?.toLowerCase() === "shortlisted"
//   ) || [];
//   const scheduledJobs = userApplication?.filter(app => 
//     app.status?.toLowerCase() === "scheduled"
//   ) || [];
//   const InterviewedJobs = userApplication?.filter(app => 
//     app.status?.toLowerCase() === "interviewed"
//   ) || [];
//   const rejectedJobs = userApplication?.filter(app => 
//     app.status?.toLowerCase() === "rejected"
//   ) || [];
//   const hiredJobs = userApplication?.filter(app => 
//     app.status?.toLowerCase() === "offer" || app.status?.toLowerCase() === "accepted"
//   ) || [];
  
//   // Check for new shortlisted or interviewed statuses
//   useEffect(() => {
//     const hasNewShortlisted = appliedJobs.some(app => app.status?.toLowerCase() === "shortlisted");
//     const hasNewInterviewed = scheduledJobs.some(app => app.status?.toLowerCase() === "interviewed");

//     if (hasNewShortlisted) {
//       setNotificationMessage("Congratulations! You have been shortlisted for a job.");
//       setShowNotification(true);
//     } else if (hasNewInterviewed) {
//       setNotificationMessage("Great news! You have been scheduled for an interview.");
//       setShowNotification(true);
//     }

//     // Auto-hide notification after 5 seconds
//     if (showNotification) {
//       const timer = setTimeout(() => {
//         setShowNotification(false);
//       }, 5000);
//       return () => clearTimeout(timer);
//     }
//   }, [userApplication, appliedJobs, scheduledJobs, showNotification]);

//   // Common table rendering function
//   const renderTable = (applications, title) => (
//     <div className="mb-8">
//       <h3 className="text-lg font-semibold mb-4">{title} <span className="text-sm font-normal text-gray-500">({applications.length} {applications.length === 1 ? 'job' : 'jobs'})</span></h3>
//       <div className="relative overflow-x-auto rounded-lg border border-gray-200">
//         <table className="w-full text-sm text-left">
//           <thead className="text-xs uppercase bg-gray-50">
//             <tr>
//               <th className="px-6 py-3 font-medium text-gray-500">Company</th>
//               <th className="px-6 py-3 font-medium text-gray-500">Position</th>
//               <th className="px-6 py-3 font-medium text-gray-500">Date Applied</th>
//               <th className="px-6 py-3 font-medium text-gray-500">Status</th>
//               <th className="px-6 py-3 font-medium text-gray-500">Reason</th>
//               <th className="px-6 py-3 font-medium text-gray-500 w-[100px]">Actions</th>
//             </tr>
//           </thead>
//           <tbody className="divide-y divide-gray-200">
//             {applications?.length > 0 ? (
//               applications.map((app, index) => (
//                 <tr
//                   key={index}
//                   className="bg-white hover:bg-gray-50 transition-colors"
//                 >
//                   <td className="px-6 py-4">
//                     <div>
//                       <div className="font-semibold">
//                         {app.companyId?.companyName || "N/A"}
//                       </div>
//                       <div className="text-sm text-gray-500">
//                         {app.companyAddress || "N/A"}
//                       </div>
//                     </div>
//                   </td>
//                   <td className="px-6 py-4">{app.position || "N/A"}</td>
//                   <td className="px-6 py-4">
//                     {app.createdAt ? new Date(app.createdAt).toLocaleDateString() : "N/A"}
//                   </td>
//                   <td className="px-6 py-4">
//                     <span
//                       className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor(
//                         app.status
//                       )}`}
//                     >
//                       {app.status || "N/A"}
//                     </span>
//                   </td>
//                   <td className="px-6 py-4">
//                     <span
//                       className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor(
//                         app.reasonForRejection
//                       )}`}
//                     >
//                       {app.reasonForRejection || "N/A"}
//                     </span>
//                   </td>
//                   <td className="px-6 py-4">
//                     <button
//                       onClick={() => {
//                         setSelectedApp(app);
//                         setIsModalOpen(true);
//                       }}
//                       className="p-2 hover:bg-gray-100 rounded-full transition-colors"
//                     >
//                       <MdBorderHorizontal className="w-4 h-4" />
//                     </button>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="6" className="px-6 py-4 text-center text-gray-500">
//                   No applications found
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );

//   return (
//     <Card className="w-full">
//       <CardHeader>
//         <CardTitle className="text-xl font-semibold">
//           Application Records
//         </CardTitle>
//       </CardHeader>
//       <CardContent>
//         {renderTable(appliedJobs, "Applied Jobs")}
//         {renderTable(scheduledJobs, "Scheduled Jobs (Interviews)")}
//         {renderTable(InterviewedJobs, "Interviewed Jobs ")}
//         {renderTable(rejectedJobs, "Rejected Jobs")}
//         {renderTable(hiredJobs, "Hired Jobs")}

//         {/* Notification Banner */}
//         {showNotification && (
//           <div className="fixed top-4 right-4 bg-green-100 text-green-800 p-4 rounded-lg shadow-lg z-50 animate-fade-in-out">
//             <span>{notificationMessage}</span>
//             <button
//               onClick={() => setShowNotification(false)}
//               className="ml-4 text-green-800 hover:text-green-600"
//             >
//               ×
//             </button>
//           </div>
//         )}

//         <Dialog isOpen={isModalOpen} onClose={handleCloseModal}>
//           {selectedApp && (
//             <>
//               <DialogTitle>Application Details</DialogTitle>
//               <div className="space-y-4">
//                 <div>
//                   <h3 className="font-semibold text-lg">
//                     {selectedApp.companyId?.companyName || "N/A"}
//                   </h3>
//                   <p className="text-gray-500">{selectedApp.companyAddress || "N/A"}</p>
//                 </div>

//                 <div className="grid grid-cols-2 gap-4">
//                   <div>
//                     <p className="text-sm text-gray-500">Position</p>
//                     <p className="font-medium">{selectedApp.position || "N/A"}</p>
//                   </div>
//                   <div>
//                     <p className="text-sm text-gray-500">Status</p>
//                     <span
//                       className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor(
//                         selectedApp.status
//                       )}`}
//                     >
//                       {selectedApp.status || "N/A"}
//                     </span>
//                   </div>
//                   <div>
//                     <p className="text-sm text-gray-500">Date Applied</p>
//                     <p className="font-medium">
//                       {selectedApp.createdAt ? new Date(selectedApp.createdAt).toLocaleDateString() : "N/A"}
//                     </p>
//                   </div>
//                   <div>
//                     <p className="text-sm text-gray-500">Availability</p>
//                     <p className="font-medium">{selectedApp.availability || "N/A"}</p>
//                   </div>
//                   <div>
//                     <p className="text-sm text-gray-500">Open for Students</p>
//                     <p className="font-medium">{selectedApp.openForStudents || "N/A"}</p>
//                   </div>
//                   {selectedApp.dateHired && (
//                     <div>
//                       <p className="text-sm text-gray-500">Date Hired</p>
//                       <p className="font-medium">{selectedApp.dateHired}</p>
//                     </div>
//                   )}
//                   {selectedApp.reasonForRejection && (
//                     <div>
//                       <p className="text-sm text-gray-500">Reason for Rejection</p>
//                       <p className="font-medium">{selectedApp.reasonForRejection}</p>
//                     </div>
//                   )}
//                 </div>

//                 <div>
//                   <p className="text-sm text-gray-500">Cover Letter</p>
//                   <p className="font-medium">{selectedApp.coverLetter || "N/A"}</p>
//                 </div>
//                 <div>
//                   <p className="text-sm text-gray-500">Resume</p>
//                   <img
//                     src={selectedApp.resume || "N/A"}
//                     alt="resume-picture"
//                     className="font-medium"
//                   />
//                 </div>
//                 {selectedApp.additionalDocument && (
//                   <div>
//                     <p className="text-sm text-gray-500">Additional Document</p>
//                     <p className="font-medium">{selectedApp.additionalDocument}</p>
//                   </div>
//                 )}
//                 {selectedApp.additionalQuestionResponse?.length > 0 && (
//                   <div>
//                     <p className="text-sm text-gray-500">Additional Questions</p>
//                     <ul className="list-disc pl-5">
//                       {selectedApp.additionalQuestionResponse.map((resp, index) => (
//                         <li key={index} className="font-medium">
//                           {typeof resp === 'object' && resp !== null ? (
//                             <>
//                               <span className="font-semibold">Question: </span>{resp.question || "N/A"}
//                               <br />
//                               <span className="font-semibold">Response: </span>{resp.response || "N/A"}
//                             </>
//                           ) : (
//                             resp
//                           )}
//                         </li>
//                       ))}
//                     </ul>
//                   </div>
//                 )}

//                 <button
//                   onClick={() =>
//                     (window.location.href = `/${selectedApp._id}/applicationStatus`)
//                   }
//                   className="w-full mt-4 inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
//                 >
//                   <FaExternalLinkAlt className="w-4 h-4 mr-2" />
//                   Track Application
//                 </button>
//               </div>
//             </>
//           )}
//         </Dialog>
//       </CardContent>
//     </Card>
//   );
// };

// export default ApplicationTable;





import React, { useState, useEffect } from "react";
import { Card, CardHeader, CardTitle, CardContent } from "./Card";
import { Dialog, DialogTitle } from "./DialogBox";
import { MdBorderHorizontal } from "react-icons/md";
import { FaExternalLinkAlt } from "react-icons/fa";

const ApplicationTable = ({ userApplication }) => {
  const [selectedApp, setSelectedApp] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState("");

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedApp(null);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "Applied":
        return "bg-yellow-100 text-yellow-800";
      case "Shortlisted":
        return "bg-blue-100 text-yellow-800";
      case "Scheduled":
        return "bg-purple-100 text-purple-800";
      case "Interviewed":
        return "bg-pink-100 text-purple-800";
      case "Rejected":
        return "bg-red-100 text-red-800";
      case "Offer":
      case "Accepted":
        return "bg-green-100 text-green-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  // Filter applications by status, ensuring case-insensitive comparison
  const appliedJobs = userApplication?.filter(app => 
    app.status?.toLowerCase() === "applied" || app.status?.toLowerCase() === "shortlisted"
  ) || [];
  const scheduledJobs = userApplication?.filter(app => 
    app.status?.toLowerCase() === "scheduled"
  ) || [];
  const InterviewedJobs = userApplication?.filter(app => 
    app.status?.toLowerCase() === "interviewed"
  ) || [];
  const rejectedJobs = userApplication?.filter(app => 
    app.status?.toLowerCase() === "rejected"
  ) || [];
  const hiredJobs = userApplication?.filter(app => 
    app.status?.toLowerCase() === "offer" || app.status?.toLowerCase() === "accepted"
  ) || [];
  
  // Check for new shortlisted or interviewed statuses
  useEffect(() => {
    const hasNewShortlisted = appliedJobs.some(app => app.status?.toLowerCase() === "shortlisted");
    const hasNewInterviewed = scheduledJobs.some(app => app.status?.toLowerCase() === "interviewed");

    if (hasNewShortlisted) {
      setNotificationMessage("Congratulations! You have been shortlisted for a job.");
      setShowNotification(true);
    } else if (hasNewInterviewed) {
      setNotificationMessage("Great news! You have been scheduled for an interview.");
      setShowNotification(true);
    }

    if (showNotification) {
      const timer = setTimeout(() => {
        setShowNotification(false);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [userApplication, appliedJobs, scheduledJobs, showNotification]);

  // Mobile Card View Component
  const ApplicationCard = ({ app }) => (
    <div className="bg-white border border-gray-200 rounded-xl p-5 mb-4 shadow-sm hover:shadow-md transition-all">
      <div className="flex justify-between items-start mb-4">
        <div>
          <h4 className="font-semibold text-lg leading-tight">
            {app.companyId?.companyName || "N/A"}
          </h4>
          <p className="text-gray-500 text-sm mt-1">
            {app.companyAddress || "N/A"}
          </p>
        </div>
        <button
          onClick={() => {
            setSelectedApp(app);
            setIsModalOpen(true);
          }}
          className="p-2 hover:bg-gray-100 rounded-full transition-colors"
        >
          <MdBorderHorizontal className="w-5 h-5" />
        </button>
      </div>

      <div className="space-y-3 text-sm">
        <div className="flex justify-between">
          <span className="text-gray-500">Position:</span>
          <span className="font-medium text-right">{app.position || "N/A"}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-500">Date Applied:</span>
          <span className="font-medium">
            {app.createdAt ? new Date(app.createdAt).toLocaleDateString() : "N/A"}
          </span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-gray-500">Status:</span>
          <span
            className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${getStatusColor(app.status)}`}
          >
            {app.status || "N/A"}
          </span>
        </div>
        {app.reasonForRejection && (
          <div className="flex justify-between">
            <span className="text-gray-500">Reason:</span>
            <span className="font-medium text-red-600">{app.reasonForRejection}</span>
          </div>
        )}
      </div>

      <button
        onClick={() =>
          (window.location.href = `/${app._id}/applicationStatus`)
        }
        className="w-full mt-5 inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-lg text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 transition-colors"
      >
        <FaExternalLinkAlt className="w-4 h-4 mr-2" />
        Track Application
      </button>
    </div>
  );

  // Common rendering function (Table on large screens, Cards on mobile)
  const renderSection = (applications, title) => {
    if (applications.length === 0) return null;

    return (
      <div className="mb-10">
        <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
          {title}
          <span className="text-sm font-normal text-gray-500">
            ({applications.length} {applications.length === 1 ? 'job' : 'jobs'})
          </span>
        </h3>

        {/* Mobile: Card View */}
        <div className="block md:hidden space-y-4">
          {applications.map((app, index) => (
            <ApplicationCard key={index} app={app} />
          ))}
        </div>

        {/* Desktop: Table View */}
        <div className="hidden md:block relative overflow-x-auto rounded-lg border border-gray-200">
          <table className="w-full text-sm text-left">
            <thead className="text-xs uppercase bg-gray-50">
              <tr>
                <th className="px-6 py-3 font-medium text-gray-500">Company</th>
                <th className="px-6 py-3 font-medium text-gray-500">Position</th>
                <th className="px-6 py-3 font-medium text-gray-500">Date Applied</th>
                <th className="px-6 py-3 font-medium text-gray-500">Status</th>
                <th className="px-6 py-3 font-medium text-gray-500">Reason</th>
                <th className="px-6 py-3 font-medium text-gray-500 w-[100px]">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {applications.map((app, index) => (
                <tr
                  key={index}
                  className="bg-white hover:bg-gray-50 transition-colors"
                >
                  <td className="px-6 py-4">
                    <div>
                      <div className="font-semibold">
                        {app.companyId?.companyName || "N/A"}
                      </div>
                      <div className="text-sm text-gray-500">
                        {app.companyAddress || "N/A"}
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4">{app.position || "N/A"}</td>
                  <td className="px-6 py-4">
                    {app.createdAt ? new Date(app.createdAt).toLocaleDateString() : "N/A"}
                  </td>
                  <td className="px-6 py-4">
                    <span
                      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor(
                        app.status
                      )}`}
                    >
                      {app.status || "N/A"}
                    </span>
                  </td>
                  <td className="px-6 py-4">
                    <span
                      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor(
                        app.reasonForRejection
                      )}`}
                    >
                      {app.reasonForRejection || "N/A"}
                    </span>
                  </td>
                  <td className="px-6 py-4">
                    <button
                      onClick={() => {
                        setSelectedApp(app);
                        setIsModalOpen(true);
                      }}
                      className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                    >
                      <MdBorderHorizontal className="w-4 h-4" />
                    </button>
                  </td>
                </tr>
              ))}
              {applications.length === 0 && (
                <tr>
                  <td colSpan="6" className="px-6 py-4 text-center text-gray-500">
                    No applications found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  return (
    <Card className="w-full">
      <CardHeader>
        <CardTitle className="text-xl font-semibold">
          Application Records
        </CardTitle>
      </CardHeader>
      <CardContent className="px-0 md:px-0">
        {renderSection(appliedJobs, "Applied Jobs")}
        {renderSection(scheduledJobs, "Scheduled Jobs (Interviews)")}
        {renderSection(InterviewedJobs, "Interviewed Jobs")}
        {renderSection(rejectedJobs, "Rejected Jobs")}
        {renderSection(hiredJobs, "Hired Jobs")}

        {/* Notification Banner */}
        {showNotification && (
          <div className="fixed top-4 right-4 bg-green-100 text-green-800 p-4 rounded-lg shadow-lg z-50 animate-fade-in-out max-w-[90%] md:max-w-sm">
            <span>{notificationMessage}</span>
            <button
              onClick={() => setShowNotification(false)}
              className="ml-4 text-green-800 hover:text-green-600 font-bold"
            >
              ×
            </button>
          </div>
        )}

        <Dialog isOpen={isModalOpen} onClose={handleCloseModal}>
          {selectedApp && (
            <>
              <DialogTitle>Application Details</DialogTitle>
              <div className="space-y-4">
                <div>
                  <h3 className="font-semibold text-lg">
                    {selectedApp.companyId?.companyName || "N/A"}
                  </h3>
                  <p className="text-gray-500">{selectedApp.companyAddress || "N/A"}</p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <p className="text-sm text-gray-500">Position</p>
                    <p className="font-medium">{selectedApp.position || "N/A"}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Status</p>
                    <span
                      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor(
                        selectedApp.status
                      )}`}
                    >
                      {selectedApp.status || "N/A"}
                    </span>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Date Applied</p>
                    <p className="font-medium">
                      {selectedApp.createdAt ? new Date(selectedApp.createdAt).toLocaleDateString() : "N/A"}
                    </p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Availability</p>
                    <p className="font-medium">{selectedApp.availability || "N/A"}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Open for Students</p>
                    <p className="font-medium">{selectedApp.openForStudents || "N/A"}</p>
                  </div>
                  {selectedApp.dateHired && (
                    <div>
                      <p className="text-sm text-gray-500">Date Hired</p>
                      <p className="font-medium">{selectedApp.dateHired}</p>
                    </div>
                  )}
                  {selectedApp.reasonForRejection && (
                    <div>
                      <p className="text-sm text-gray-500">Reason for Rejection</p>
                      <p className="font-medium">{selectedApp.reasonForRejection}</p>
                    </div>
                  )}
                </div>

                <div>
                  <p className="text-sm text-gray-500">Cover Letter</p>
                  <p className="font-medium">{selectedApp.coverLetter || "N/A"}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Resume</p>
                  <img
                    src={selectedApp.resume || "N/A"}
                    alt="resume-picture"
                    className="font-medium max-w-full h-auto rounded"
                  />
                </div>
                {selectedApp.additionalDocument && (
                  <div>
                    <p className="text-sm text-gray-500">Additional Document</p>
                    <p className="font-medium">{selectedApp.additionalDocument}</p>
                  </div>
                )}
                {selectedApp.additionalQuestionResponse?.length > 0 && (
                  <div>
                    <p className="text-sm text-gray-500">Additional Questions</p>
                    <ul className="list-disc pl-5">
                      {selectedApp.additionalQuestionResponse.map((resp, index) => (
                        <li key={index} className="font-medium">
                          {typeof resp === 'object' && resp !== null ? (
                            <>
                              <span className="font-semibold">Question: </span>{resp.question || "N/A"}
                              <br />
                              <span className="font-semibold">Response: </span>{resp.response || "N/A"}
                            </>
                          ) : (
                            resp
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                <button
                  onClick={() =>
                    (window.location.href = `/${selectedApp._id}/applicationStatus`)
                  }
                  className="w-full mt-4 inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                  <FaExternalLinkAlt className="w-4 h-4 mr-2" />
                  Track Application
                </button>
              </div>
            </>
          )}
        </Dialog>
      </CardContent>
    </Card>
  );
};

export default ApplicationTable;